/* Sticker Foot — petits comportements du thème (sans dépendance) */
(function () {
  'use strict';
  var btt = document.getElementById('sf-back-to-top');
  var bar = document.getElementById('sf-sticky-atc');
  var ticking = false;

  function getSubmit() {
    return document.querySelector('.product-form__submit');
  }

  function update() {
    ticking = false;
    if (btt) btt.classList.toggle('is-visible', window.scrollY > 600);
    if (bar) {
      var btn = getSubmit();
      var footer = document.querySelector('footer');
      var pastButton = btn ? btn.getBoundingClientRect().bottom < 0 : false;
      var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var show = pastButton && !nearFooter;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('sf-has-sticky', show);
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  if (btt) {
    btt.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  if (bar) {
    var sticky = bar.querySelector('[data-sf-sticky-atc]');
    if (sticky) {
      sticky.addEventListener('click', function () {
        var btn = getSubmit();
        if (btn) btn.click();
      });
    }
  }
  update();
})();

/* Description produit : repliée avec « Voir plus » quand elle est très longue */
(function () {
  'use strict';
  function init() {
    var d = document.querySelector('.product__description');
    if (!d || d.dataset.sfCollapse) return;
    d.dataset.sfCollapse = '1';
    if (d.scrollHeight < 560) return;
    d.classList.add('sf-collapsible', 'is-collapsed');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sf-more-btn';
    b.textContent = 'Voir plus';
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      var open = d.classList.toggle('is-collapsed');
      b.textContent = open ? 'Voir plus' : 'Voir moins';
      b.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
    d.insertAdjacentElement('afterend', b);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* Date de livraison estimée (environ 7 jours) */
(function () {
  try {
    var els = document.querySelectorAll('[data-sf-eta]');
    if (!els.length) return;
    function addDays(n) {
      var d = new Date(); d.setDate(d.getDate() + n);
      if (d.getDay() === 0) d.setDate(d.getDate() + 1);
      return d;
    }
    var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    var a = fmt.format(addDays(6)), b = fmt.format(addDays(8));
    els.forEach(function (e) { e.textContent = 'Estimée entre le ' + a + ' et le ' + b + ' · offerte dès 29 €'; });
  } catch (e) {}
})();
